import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import Linkify from 'linkify-react';

interface LinkifiedTextProps {
  text: string;
  variant?: TypographyProps['variant'];
  sx?: TypographyProps['sx'];
  className?: string;
}

/**
 * テキスト内のURLを自動的にリンク化するコンポーネント
 * 
 * 機能:
 * - http:// および https:// で始まるURLを検出
 * - クリック可能なリンクに変換
 * - 新しいタブで開く（target="_blank"）
 * - セキュリティ対策（rel="noopener noreferrer"）
 * 
 * @param text - リンク化対象のテキスト
 * @param variant - Material-UI Typography のvariant
 * @param sx - Material-UI style object
 * @param className - 追加CSSクラス
 */
export const LinkifiedText: React.FC<LinkifiedTextProps> = ({
  text,
  variant = 'body1',
  sx = {},
  className,
}) => {
  // linkify-react の options 設定
  const options = {
    // リンクの属性カスタマイズ
    attributes: {
      target: '_blank',
      rel: 'noopener noreferrer',
    },
    // リンクのCSSクラス
    className: 'linkified-url',
    // カスタムレンダリング（Material-UIスタイル適用）
    render: ({ attributes, content }: any) => {
      return (
        <a
          {...attributes}
          style={{
            color: '#2E5BBA',
            textDecoration: 'underline',
            wordBreak: 'break-all',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#1E3F8A';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#2E5BBA';
          }}
        >
          {content}
        </a>
      );
    },
  };

  return (
    <Typography
      variant={variant}
      sx={{
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        ...sx,
      }}
      className={className}
    >
      <Linkify options={options}>{text}</Linkify>
    </Typography>
  );
};

